/**
 * Reserves the strip the note indicators are drawn in, and mirrors it on the left so the
 * text keeps even margins. `right` resolves against the padding box, so padding a text box
 * steps the text back, not the indicator.
 */

/** Marks a pane indicators may portal into; inert in CSS. */
export const ANNOTATION_INDICATOR_PANE_ATTRIBUTE = 'data-annotation-indicator-pane';

/** For each pane that scrolls annotatable content itself; content scrollers stay unmarked. */
export const ANNOTATION_INDICATOR_PANE_PROPS = {
  [ANNOTATION_INDICATOR_PANE_ATTRIBUTE]: ''
} as const;

/** Set on the question area while annotations are available; scopes the reserve below. */
export const ANNOTATION_GUTTER_PROPS = {
  'data-annotation-gutter': '',
  ...ANNOTATION_INDICATOR_PANE_PROPS
} as const;

/**
 * Belongs on whichever box the annotatable text wraps in. Spelled out rather than
 * composed: Tailwind extracts candidates as static text, so interpolation emits none.
 */
export const ANNOTATION_GUTTER_CLASS = '[[data-annotation-gutter]_&]:px-x4';
